import { Middleware } from 'redux';

import * as authConstants from 'redux/constants/auth.constants';
import * as blocksConstants from 'redux/constants/blocks.constants';
import * as categoryPricesConstants from 'redux/constants/categoryPrices.constants';
import * as cementeriesConstants from 'redux/constants/cementeries.constants';
import * as contactSettingsConstants from 'redux/constants/contactSettings.constants';
import * as divorcesConstants from 'redux/constants/divorces.constants';
import * as deathsConstants from 'redux/constants/deaths.constants';
import * as documentsConstants from 'redux/constants/documents.constants';
import * as documentsTypesConstants from 'redux/constants/documentsTypes.constants';
import * as gravesConstants from 'redux/constants/graves.constants';
import * as jewishnessConstants from 'redux/constants/jewishness.constants';
import * as marriagesConstants from 'redux/constants/marriages.constants';
import * as matzevaConstants from 'redux/constants/matzeva.constants';
import * as permissionsConstants from 'redux/constants/permissions.constants';
import * as personsConstants from 'redux/constants/persons.constants';
import * as proceduresConstants from 'redux/constants/procedures.constants';
import * as reservationsConstants from 'redux/constants/reservations.constants';
import * as rolesConstants from 'redux/constants/roles.constants';
import * as usersConstants from 'redux/constants/users.constants';
import { history } from 'helpers/history';

const redirectMiddleware: Middleware = () => (next) => (action) => {
  const { data, error, pathname, type } = action;
  switch (type) {
    case authConstants.AUTH_ON_LOGIN_SUCCEEDED:
      setTimeout(() => history.push(pathname || '/dashboard'), 0);
      break;
    case authConstants.AUTH_ON_LOGIN_PUBLIC_SUCCEEDED:
      setTimeout(() => history.push(pathname || '/public'), 0);
      break;
    case authConstants.AUTH_ON_LOGOUT_SUCCEEDED:
    case authConstants.AUTH_ON_INITIALIZE_FAILED:
      // setTimeout(() => history.push('/login'), 0);
      // Depende de la ruta si es pública o privada, si va al login
      break;
    case authConstants.AUTH_ON_REGISTER_PUBLIC_SUCCEEDED:
      setTimeout(() => {
        history.push({
          pathname: '/public/procedures/login',
          state: {
            registrationSuccess: true,
            message: data.message || 'Registro exitoso. Revisa tu email.',
          },
        });
      }, 0);
      break;
    case authConstants.AUTH_ON_LOGOUT_PUBLIC_SUCCEEDED:
      setTimeout(() => history.push('/public'), 0);
      break;
    case authConstants.AUTH_ON_CHANGE_PASSWORD_SUCCEEDED:
      setTimeout(() => history.push('/public/procedures/login'), 0);
      break;
    case blocksConstants.BLOCKS_ON_SAVE_SUCCEEDED:
      history.push(`/cementeries/${data.cementeryId}/blocks`);
      break;
    case categoryPricesConstants.CATEGORY_PRICES_ON_SAVE_SUCCEEDED:
      history.push('/category-prices');
      break;
    case cementeriesConstants.CEMENTERIES_ON_SAVE_SUCCEEDED:
      history.push('/cementeries');
      break;
    case contactSettingsConstants.SETTINGS_ON_SAVE_CONTACT_SUCCEEDED:
      history.push('/contact-settings');
      break;
    case contactSettingsConstants.SEND_CONTACT_EMAIL_SUCCEEDED:
      history.push('/public');
      break;
    case divorcesConstants.DIVORCES_ON_SAVE_SUCCEEDED:
      history.push(`/public/procedures/forms/divorces/${data.item.id}/show`);
      break;
    case deathsConstants.DEATHS_ON_SAVE_SUCCEEDED:
      history.push(`/public/procedures/forms/deaths/${data.item.id}/show`);
      break;
    case documentsConstants.DOCUMENTS_ON_DELETE_SUCCEEDED:
    case documentsConstants.DOCUMENTS_ON_SAVE_SUCCEEDED:
      history.push('/persons');
      break;
    case documentsTypesConstants.DOCUMENTS_TYPES_ON_SAVE_SUCCEEDED:
      history.push('/documents/types/list');
      break;
    case gravesConstants.GRAVES_ON_DELETE_SUCCEEDED:
    case gravesConstants.GRAVES_ON_SAVE_SUCCEEDED:
      history.push(`/cementeries/${data.cementeryId}/blocks/${data.blockId}/show`);
      break;
    case jewishnessConstants.JEWISHNESS_ON_SAVE_SUCCEEDED:
      history.push(`/public/procedures/forms/jewishness/${data.item.id}/show`);
      break;
    case marriagesConstants.MARRIAGES_ON_SAVE_SUCCEEDED:
      history.push(`/public/procedures/forms/marriages/${data.item.id}/show`);
      break;
    case matzevaConstants.MATZEVA_ON_SAVE_SUCCEEDED:
      history.push(`/public/procedures/forms/matzeva/${data.item.id}/show`);
      break;
    case permissionsConstants.PERMISSIONS_ON_SAVE_SUCCEEDED:
      history.push('/users/permissions/list');
      break;
    case personsConstants.PERSONS_ON_SAVE_SUCCEEDED:
      history.push('/persons');
      break;
    case proceduresConstants.PROCEDURES_ON_SAVE_SUCCEEDED:
      history.push('/procedures');
      break;
    case rolesConstants.ROLES_ON_SAVE_SUCCEEDED:
      history.push('/users/roles/list');
      break;
    case reservationsConstants.RESERVATIONS_ON_SAVE_SUCCEEDED:
      history.push(`/public/procedures/forms/reservations/${data.item.id}/show`);
      break;
    case usersConstants.USERS_ON_SAVE_SUCCEEDED:
      history.push('/users/list');
      break;
    case authConstants.AUTH_ON_RESET_PASSWORD_FAILED:
    case authConstants.AUTH_ON_CHANGE_PASSWORD_FAILED:
    case authConstants.AUTH_ON_LOGIN_FAILED:
    case authConstants.AUTH_ON_LOGIN_PUBLIC_FAILED:
      break;
    default:
      if (error?.response?.status === 401) setTimeout(() => history.push('/'), 0);
      break;
  }
  return next(action);
};

export default redirectMiddleware;
